// ############################ Require packages here ############################
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// ############################ Require files here ###############################


export default function Notfound() {
    const navigate = useNavigate();

    return (
        <div style={{ width: '100%', height: '100vh', background: "linear-gradient(41.44deg, #040C30 37.24%, #06065D 63.08%)" }}>
            {/* section 0 PAGE HEADING */}
            <Helmet>
                <title>Sequretek Not-found</title>
                <meta http-equiv="X-Frame-Options" content="DENY" />
            </Helmet>
            {/* section 1 PAGE NOT FOUND BANNER */}
            <div className='no-found-page '>
                <img src='/images/404.svg' alt='' />
                <div className='text-center'>
                    <button onClick={() => navigate(-1)}>Go Back</button>
                </div>

            </div>
        </div>
    )
}
